/**
 * SPR (SpellingRegel) Module Seeds - Consolidated Index
 *
 * Modular seed structure matching GET/TGL pattern.
 * Each family is stored in its own JSON file.
 *
 * Phase H-5: Migrated from flat seed_SPR.json to folder-based pattern.
 */

import SPR_KLANK_JAGER from './SPR-KLANK-JAGER.json'
import SPR_KLANK_BAKKER from './SPR-KLANK-BAKKER.json'
import SPR_KLANK_AA_EE_OO from './SPR-KLANK-AA-EE-OO.json'
import SPR_HOOFDLETTER from './SPR-HOOFDLETTER.json'
import SPR_WEET_EI_IJ from './SPR-WEET-EI-IJ.json'
import SPR_WEET_D_T from './SPR-WEET-D-T.json'
import SPR_LEEN_C_S_K from './SPR-LEEN-C-S-K.json'
import SPR_TREMA_MV from './SPR-TREMA-MV.json'
import SPR_LEEN_FRANS from './SPR-LEEN-FRANS.json'
import SPR_SAM_TUSSEN_N from './SPR-SAM-TUSSEN-N.json'
import SPR_LEEN_ENGELS from './SPR-LEEN-ENGELS.json'
import SPR_LEEN_LATIJN from './SPR-LEEN-LATIJN.json'
import SPR_ACCENT from './SPR-ACCENT.json'

const SPR_FAMILY_SEEDS = [
  { file: 'src/data/seeds/SPR/SPR-KLANK-JAGER.json', data: SPR_KLANK_JAGER },
  { file: 'src/data/seeds/SPR/SPR-KLANK-BAKKER.json', data: SPR_KLANK_BAKKER },
  {
    file: 'src/data/seeds/SPR/SPR-KLANK-AA-EE-OO.json',
    data: SPR_KLANK_AA_EE_OO,
  },
  { file: 'src/data/seeds/SPR/SPR-HOOFDLETTER.json', data: SPR_HOOFDLETTER },
  { file: 'src/data/seeds/SPR/SPR-WEET-EI-IJ.json', data: SPR_WEET_EI_IJ },
  { file: 'src/data/seeds/SPR/SPR-WEET-D-T.json', data: SPR_WEET_D_T },
  { file: 'src/data/seeds/SPR/SPR-LEEN-C-S-K.json', data: SPR_LEEN_C_S_K },
  { file: 'src/data/seeds/SPR/SPR-TREMA-MV.json', data: SPR_TREMA_MV },
  { file: 'src/data/seeds/SPR/SPR-LEEN-FRANS.json', data: SPR_LEEN_FRANS },
  { file: 'src/data/seeds/SPR/SPR-SAM-TUSSEN-N.json', data: SPR_SAM_TUSSEN_N },
  { file: 'src/data/seeds/SPR/SPR-LEEN-ENGELS.json', data: SPR_LEEN_ENGELS },
  { file: 'src/data/seeds/SPR/SPR-LEEN-LATIJN.json', data: SPR_LEEN_LATIJN },
  { file: 'src/data/seeds/SPR/SPR-ACCENT.json', data: SPR_ACCENT },
] as const

const allQuestions = SPR_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question: any) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'SpellingRegel' as const,
  moduleCode: 'SPR',
  version: '5.2-modular',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
